module.exports = __webpack_public_path__ + "static/media/lasta-grip-goldenoak.71753618.png";